import '@babel/polyfill'
import 'nodelist-foreach-polyfill'

const wordSelectors = {
  option: ['.title-format']
}

export default () => {

  const words = document.querySelectorAll(wordSelectors.option)

  words.forEach((word, index) => {

    let input = word.textContent;
    let toReplace = '©';
    let newWord = `<sup>${toReplace}</sup>`;
    let regEx = new RegExp(toReplace,"g");
    let output = input.replace(regEx, newWord);
    //console.log(output);
    word.innerHTML = output;

  });

}
